<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
        <el-input :style="{width: '20%'}" v-model="keyword" placeholder="请输入uuid" @keyup.enter.native="getUsers"></el-input>
        <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="contracts" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="uuid"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.uuid }}</span>
        </template>
      </el-table-column>

      <el-table-column label="路径" width="">
        <template slot-scope="scope">
          <a :href="scope.row.file_url" target="_blank">查看</a>
        </template>
      </el-table-column>

      <el-table-column label="合同号" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.contract_number }}</span>
        </template>
      </el-table-column>

      <el-table-column label="类型" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>

      <el-table-column label="用户名" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.user_name }}</span>
        </template>
      </el-table-column>

    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
    import { getContractList } from '../../api/api';
    export default {
      created() {
        this.listLoading = true;
        //get list
        getContractList()
          .then((res) => {
            if(res.status === 0){
              this.contracts = res.data.data;
              this.total_count = res.data.total_count;
              this.listLoading = false;
              if(res.data.total_pages < 2){
                this.pagination = false;
              }
            }
          })
      },
      beforeRouteUpdate(to, from, next) {
        this.listLoading = true;
        //get list
        getContractList(to.query)
          .then((res) => {
            if(res.status === 0){
              this.contracts = res.data.data;
              this.total_count = res.data.total_count;
              this.listLoading = false;
              if(res.data.total_pages < 2){
                this.pagination = false;
              }
            }
          })
      },
      data() {
        return {
          keyword: '',
          currentPage: 1,
          contracts: [],
          listLoading: false,
          total_count: 0,
          pagination: true
        }
      },
      methods: {
        getUsers() {
          let params = {
            'search[keyword]': this.keyword,
            'page': this.currentPage
          };
          getContractList(params).then((res) => {
            if(res.status === 0){
              this.contracts = res.data.data;
              this.total_count = res.data.total_count;
              if(res.data.total_pages < 2){
                this.pagination = false;
              }else {
                this.pagination = true;
              }
            }
          })
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.getUsers();
        },
      }
    }

</script>

<style lang="scss">
  @import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/Contracts.vue